import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function RouteIntercept({ children }) {
    useEffect(() => {
        function interceptAnchorClick(event) {
            let anchor;

            if (event.target.tagName === 'A') {
                // if the event target is an anchor
                // assign it to anchor
                anchor = event.target;
            } else {
                anchor = event.target.closest('A');
            }

            if (!anchor) return;

            // Intercept skip-to-content links from lit web components
            if (anchor.getAttribute('href') === '#main-content') {
                event.preventDefault();
                const element = document.querySelector('#main-content');
                if (element) {
                    element.focus();
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }

            // Intercept href="#" links from lit web components (e.g.
            // ii-footer) that use anchor tags to trigger modals. Without
            // this, react-router interprets the "#" navigation as a route
            // change to "/#" on non-root routes.
            if (anchor.getAttribute('href') === '#') {
                event.preventDefault();
            }
        }

        document.body.addEventListener('click', interceptAnchorClick, true);

        return () => {
            document.body.removeEventListener(
                'click',
                interceptAnchorClick,
                true
            );
        };
    }, []);

    return children;
}

export default withRouter(RouteIntercept);
